export const SET_USER_CHAT = "SET_USER_CHAT";
export const CLOSE_USER_CHAT = "CLOSE_USER_CHAT";
export const SET_LATEST_MESSAGE = "SET_LATEST_MESSAGE";
export const CLOSE_ALL_CHATS = "CLOSE_ALL_CHATS";
